import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import LearnerAcrossFacetsChart from '@/components/charts/learner-across-facets-chart/learner-across-facets-chart';
import LearnerProficiency from '@/components/proficiency/learner-proficiency/learner-proficiency';
import FacetsInfoPanel from '@/components/proficiency/facets-info-panel/facets-info-panel';
import MonthYearPicker from '@/components/selector/month-year-picker/month-year-picker';
import TaxonomyFilter from '@/components/selector/taxonomy-filter/taxonomy-filter';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { SubjectModel } from '@/models/taxonomy/subject';
import { User } from '@/models/profile/user';
import { profileAPI } from '@/providers/apis/profile/profile';
import moment from 'moment';
import AboutMe from '../about-me/about-me';
import { appConfigService } from '@/providers/services/app/app-config';
import { sessionService } from '@/providers/services/auth/session';
import { classAPI } from '@/providers/apis/class/class';
import { UserClassModel } from '@/models/class/class';

@Component({
  name: 'learner-facets-proficiency',
  components: {
    'learner-across-facets-chart': LearnerAcrossFacetsChart,
    'facets-info-panel': FacetsInfoPanel,
    'month-year-picker': MonthYearPicker,
    'learner-proficiency': LearnerProficiency,
    'taxonomy-filter': TaxonomyFilter,
    'google-material-icon': GoogleMaterialIcon,
    'about-me': AboutMe,
  },
})

export default class LearnerFacetsProficiency extends Vue {

  private get learnerId() {
    return this.$route.params.id;
  }

  private get hideBio() {
    return this.$route.query ? this.$route.query.filter : false;
  }

  private get isDemoTenant() {
    return appConfigService.isDemoTenant();
}

private get isGuestUser() {
  return this.$access.isGuestUser('guest', 'guest');
}

  private get isShowcasePage() {
    return this.$access.isShowcaseDemo && this.isShowCaseView;
  }


  public activeMonth: string = moment().format('MM');

  public activeYear: string = moment().format('YYYY');

  public isUserClassLoading: boolean = false;

  private activeClassificationCode: string = 'k_12';

  private activeSubjectCode: string = 'K12.MA';

  private isShowFacetsProficiency: boolean = true;

  private activeFacets: SubjectModel[] = [];

  private activeSubject!: SubjectModel;

  private learner: User = {};

  private isShowExpandedFacetChart: boolean = true;

  private facetsCompetencyMatrix: any = [];

  private isActiveProficiency: boolean = true;

  private userClassList: UserClassModel[] = [];

  private isShowCaseView: boolean = false;

  // -----------------------------------------------------
  // Actions

  public onChageTimeline(timeline: string) {
    const component = this;
    component.activeYear = moment(timeline).format('YYYY');
    component.activeMonth = moment(timeline).format('MM');
  }

  public onLoadSubjectData() {
    const queryParams: any = this.$route.query;
    if (queryParams.activeSubject) {
      this.isShowFacetsProficiency = false;
      const activeSubject: any = JSON.parse(decodeURIComponent(window.atob(queryParams.activeSubject)));
      this.activeSubjectCode = activeSubject.id;
      this.activeSubject = activeSubject;
    }
  }

  private created() {
    // if (this.isDemoTenant || this.isGuestUser) {
    //   this.activeMonth = '02';
    //   this.activeYear = '2020';
    // }
    const queryParams = this.$router.currentRoute.query;
    this.isShowCaseView = !!queryParams.isShowCaseView;
    if (queryParams && queryParams.activeMonth && queryParams.activeYear) {
      this.activeYear = moment((queryParams.activeYear as string), 'YYYY').format('YYYY');
      this.activeMonth = moment((queryParams.activeMonth as string), 'MM').format('MM');
      this.$router.replace({name: 'learners-proficiency', params: this.$router.currentRoute.params});
    }
    this.fetchUserClass();
    this.onLoadSubjectData();
    this.loadUserData();
  }

  private onSelectSubject(subject: SubjectModel) {
    this.activeClassificationCode = subject.code.split('.')[0];
    this.activeSubject = subject;
    this.isShowFacetsProficiency = false;
  }

  private onClickBack() {
    this.$router.back();
  }

  private backAction() {
    this.isShowFacetsProficiency = true;
  }

  private onSelectPortfolioStat(portfolioStat: any) {
    this.isActiveProficiency = portfolioStat.isProficiency ? portfolioStat.isProficiency : false;
    const subject: SubjectModel | any = this.activeFacets.find(
      (activeFacet: SubjectModel) => activeFacet.code === portfolioStat.subjectCode );
    this.activeClassificationCode = subject.code.split('.')[0];
    this.activeSubject = subject;
    this.isShowFacetsProficiency = false;
  }

  private recognizeFacetCompetencyMatrix(facetsCompetencyMatrix: any) {
    this.facetsCompetencyMatrix = facetsCompetencyMatrix;
  }

  private listActiveFacets(facets: SubjectModel[]) {
    this.activeFacets = facets;
  }

  private loadUserData() {
    const component = this;
    profileAPI.fetchUserProfiles(component.learnerId).then((userProfile: User[]) => {
      component.learner = userProfile[0];
    });
  }

  private fetchUserClass() {
      const userId = this.learnerId;
      this.isUserClassLoading = true;
      classAPI.fetchUsersClass(userId).then((classList) => {
        this.userClassList = classList;
        this.isUserClassLoading = false;
      });
  }
}
